<script setup lang="ts">
import { getDomain } from '@sembo-private/utils';
import { computed } from 'vue';

import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppLinkButton, AppSvgIcon } from '@libs/ui';

const { t } = i18n.global;

const redirectionLinkForInstalmentBanner = computed(() => {
  if (getDomain.getCurrentDomainSpec().Locale === 'sv') {
    return 'https://www.sembo.se/resor/delbetala-resan-med-captum';
  }
  if (getDomain.getCurrentDomainSpec().Locale === 'no') {
    return 'https://www.sembo.no/reiser/delbetale-reisen-med-captum';
  }
  return '';
});

function redirectTo(): void {
  window.open(redirectionLinkForInstalmentBanner.value, '_blank');
}
</script>

<template>
  <div class="instalment-banner" @click.stop="redirectTo">
    <div class="left-column">
      <AppSvgIcon name="creditCard" size="24" />
    </div>
    <div class="right-column">
      <div class="instalment-banner-title">
        {{ t('instalment_banner.title') }}
      </div>
      <AppLinkButton
        class="link"
        :text="t('planner.read_more')"
        size="large"
        :href="redirectionLinkForInstalmentBanner"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.instalment-banner {
  display: flex;
  gap: var(--spacing-12);
  padding: var(--spacing-12) var(--spacing-8);

  cursor: pointer;

  .left-column {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .right-column {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;

    .link {
      white-space: nowrap;
    }

    .instalment-banner-title {
      font: var(--font-label-l-bold);
    }
  }
}
</style>
